import dayjs from 'dayjs'
import * as React from 'react'
import { TouchableWithoutFeedback, View } from 'react-native'

import { u } from '../commonStyles'
import { useTheme } from '../theme/ThemeContext'

interface HourGuideCellProps {
  cellHeight: number
  onPress: (d: dayjs.Dayjs) => void
  date: dayjs.Dayjs
  hour: number
}

export const HourGuideCell = ({ cellHeight, onPress,date, hour }: HourGuideCellProps) => {
  const theme = useTheme()

  return (
    <TouchableWithoutFeedback onPress={() => onPress(date.hour(hour).minute(0))}>
      <View
        style={[
          theme.isRTL? u['border-r'] : u['border-l'],
          hour !=23 && u['border-b'] ,   //last row must not contain seperator
          { borderColor: theme.palette.gray['200'] },
          { height: cellHeight },
        ]}
      />
    </TouchableWithoutFeedback>
  )
}
